import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ConfirmDelete from "../../components/ui/ConfirmDelete";
import { useDelete } from "../../hooks";
import { BsPrinter } from "react-icons/bs";

export const ExpensesAction = ({
  Path,
  id,
  item1,
  path1,
  item2,
  path2,
  item3,
  icon1,
  icon2,
  icon3,
  refreshHandler,
}) => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const params = useParams();
  const [onShow, setOnShow] = useState(false);
  const { deleteItem, loading, data } = useDelete();

  const showModal = () => setOnShow(true);

  useEffect(() => {
    if (data) {
      refreshHandler();
    }
  }, [data]);

  return (
    <>
      <ConfirmDelete
        setOnShow={setOnShow}
        onShow={onShow}
        msg={t("Validate.confirm-del-expenses")}
        onDeleteHandler={async () => {
          try {
            await deleteItem(
              `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/${Path}/${id}`
            );
            setOnShow(false);
          } catch (error) {
            console.error("Error deleting item:", error);
          }
        }}
        loading={loading}
      />

      <div className="flex items-center justify-end">
        <button
          onClick={() => navigate(`/${params.tenant}${path1}/${id}`)}
          className="flex items-center justify-center text-slate-800 text-sm p-2 rounded-md transition-all"
        >
          {String(icon1 || "").includes("Print.png") ? (
            <BsPrinter className="text-[17px] text-[#261759]" />
          ) : (
            <img src={icon1} className="w-5" alt="" srcSet="" />
          )}
        </button>

        <button
          onClick={() => navigate(`/${params.tenant}${path2}/${id}`)}
          className="flex items-center text-slate-800 text-sm p-2 rounded-md transition-all"
        >
          <img src={icon2} className="w-4" alt="" srcSet="" />
        </button>

        <button
          onClick={showModal}
          className="flex items-center text-red-600 text-sm p-2 rounded-md  transition-all"
        >
          <img src={icon3} className="w-4" alt="" srcSet="" />
        </button>
      </div>
    </>
  );
};
